import { render, staticRenderFns } from "./claim-account.page.vue?vue&type=template&id=02c80349&scoped=true&"
import script from "./claim-account.page.vue?vue&type=script&lang=js&"
export * from "./claim-account.page.vue?vue&type=script&lang=js&"
import style0 from "./claim-account.page.vue?vue&type=style&index=0&id=02c80349&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c80349",
  null
  
)

export default component.exports